import { env } from '@drycut/navigation';
import { Button } from '@drycut/ui-components';
import Lightbox from 'react-datatrans-light-box';

import DatatransErrorModal from './DatatransErrorModal';

type Props = {
  datatransId?: string;
  loading?: boolean;
  onCancel: () => void;
  onErrorClose: () => void;
  transactionError?: string;
} & React.ComponentProps<typeof Button>;

export function CheckoutButton({
  datatransId,
  onCancel,
  loading = false,
  transactionError = '',
  onErrorClose,
  ...props
}: Props): React.ReactElement {
  return (
    <>
      <Button type="button" data-mode={env} loading={loading} {...props}>
        Jetzt buchen
      </Button>

      {datatransId && (
        <Lightbox
          transactionId={datatransId}
          production={env === 'production'}
          onCancelled={onCancel}
        />
      )}

      <DatatransErrorModal
        open={!!transactionError}
        error={transactionError}
        onClose={onErrorClose}
      />
    </>
  );
}
